
<template>
    <div>
        <div class="col-md-12">
            <div class="col-md-3">
                <div class="form-group">
                    <label>Km por Litro</label>
                    <input v-model="km_litro" type="text" v-mask="['##','#']" class="form-control"/>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Km por Dia </label>
                    <input v-model="km_dia" type="text" v-mask="['##','###','####']" class="form-control"/>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Valor Médio de Hospedagem</label>
                    <input v-model="valor_hospedagem" type="text" v-mask="['#,##','##,##','###,##']" class="form-control"/>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-3">
                <div class="form-group">
                    <label>Valor Médio de alimentação por dia</label>
                    <input v-model="valor_alimentacao" type="text" v-mask="['#,##','##,##']" class="form-control"/>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Valor médio do Combustível</label>
                    <input v-model="valor_combustivel" type="text" v-mask="['#,##','##,##']" class="form-control"/>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Km Extra</label>
                    <input v-model="km_extra" type="text" v-mask="['###']" class="form-control"/>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-primary" @click="saveParametro">Salvar Parametros</button>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        data() {
          return {
              km_litro:0,
              km_dia:0,
              km_extra:0,
              valor_hospedagem:0,
              valor_alimentacao:0,
              valor_combustivel:0,
              parametro_id:0
          }
        },
        methods: {
            saveParametro:function(){
                var vm = this;
                var data = {
                    edita:this.parametro_id,
                    km_litro:this.km_litro,
                    km_dia:this.km_dia,
                    km_extra:this.km_extra,
                    valor_hospedagem:this.valor_hospedagem.replace(',','.'),
                    valor_alimentacao:this.valor_alimentacao.replace(',','.'),
                    valor_combustivel:this.valor_combustivel.replace(',','.'),
                }
                axios.post('/adm/parametros/rotas/save',data).then(function(response){
                    let obj = response.data;
                    vm.$swal('success',obj.success,'success');

                    console.log(obj)
                }).catch(function(error){
                    console.log(error.response);
                });
            },
            rmParametros:function(){
                console.log('remove parametros...');
            },
            getParametros:function(){
                var vm = this;
                var arrayParametros = [];
                axios.get('/adm/parametros/rotas/list').then(function(response){

                    let obj = response.data;
                        vm.parametro_id = obj.id;
                        vm.km_dia   = obj.km_dia;
                        vm.km_litro = obj.km_litro;
                        vm.km_extra = obj.km_extra;
                        vm.valor_alimentacao    = obj.valor_alimentacao;
                        vm.valor_hospedagem     = obj.valor_hospedagem;
                        vm.valor_combustivel    = obj.valor_combustivel;

                    console.log(obj)
                }).catch(function(error){
                    console.log(error.response);
                });
            }
        },
        mounted() {
            this.getParametros();
        },
    };
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/rotas/Parametros.vue